module.exports = "<div class=\"m-xs\">\r\n    <span class=\"label label-{{item.type}}\" *ngIf=\"item.label\">{{item.label}}&nbsp;{{item.value}}</span>\r\n    <span class=\"label label-{{item.type}}\" *ngIf=\"!item.label\">{{item.value}}</span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/tag/tag.component.html
// module id = ./src/app/components/common/tag/tag.component.html
// module chunks = main